import { render, staticRenderFns } from "./BaseContactCard.vue?vue&type=template&id=564d46fc"
import script from "./BaseContactCard.vue?vue&type=script&lang=js"
export * from "./BaseContactCard.vue?vue&type=script&lang=js"
import style0 from "./BaseContactCard.vue?vue&type=style&index=0&id=564d46fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports